import React from 'react';

import Modal from 'react-modal';

import { useModal } from 'hooks/modal';

function PhotoModal() {
  const {
    modalPhotoVisible,
    photoData,
    setModalPhotoVisible
  } = useModal();

  const customStyles = {
    content : {
      top: '50%',
      border: 'none',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: 'rgba(0, 0, 0, 0)',
      width: '100%',
      height: '100%',
    },
    overlay: {
      overflow: 'auto',
      transition: '(top 0.4s, opacity 0.4s)',
      zIndex: 100000,
      background: 'rgba(0, 0, 0, 0.4)',
    }
  };
  
  return (
    <Modal
      isOpen={modalPhotoVisible}
      style={customStyles}
      onRequestClose={() => setModalPhotoVisible(false)}
      ariaHideApp={false}
      shouldCloseOnOverlayClick
    > 
    <div 
      style={{cursor: 'pointer', position: 'relative'}} 
      onClick={() => setModalPhotoVisible(false)} 
    >
      <img 
        style={{objectFit: 'scale-down', cursor: 'pointer', maxWidth: '95vw', maxHeight: '95vh'}} 
        src={photoData}
        alt="img"
      />
      <span style={{fontSize: 30, position: 'absolute', right: 15, color: 'white'}}><i class="fas fa-times"></i></span>
    </div>
    </Modal>
  );
}

export default PhotoModal;